export const vi = {
  common: {
    save: 'Lưu',
    cancel: 'Huỷ',
    retry: 'Thử lại',
    saved: 'Đã lưu',
    loadError: 'Không tải được dữ liệu',
    month: 'Tháng {{month}}',
    previousMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
  },
  status: {
    full: 'Đủ công',
    half: 'Nửa ngày',
    missing: 'Thiếu chấm công',
    absent: 'Vắng',
    pending: 'Chưa xong',
    off: 'Nghỉ',
  },
  weekday: { 1: 'T2', 2: 'T3', 3: 'T4', 4: 'T5', 5: 'T6', 6: 'T7', 7: 'CN' },
  mine: {
    title: 'Công của tôi',
    description: 'Giờ vào, giờ về và công từng ngày theo máy chấm công.',
    personTitle: 'Công của {{name}}',
    noCode:
      'Bạn chưa được ghép mã chấm công. Hãy nhờ nhân sự hành chính ghép mã trên máy chấm công với hồ sơ nhân viên của bạn.',
    units: 'Công',
    unitsOf: '{{units}} / {{days}} ngày',
    late: 'Đi muộn',
    early: 'Về sớm',
    times: '{{count}} lần · {{minutes}} phút',
    missing: 'Thiếu chấm công',
    absent: 'Vắng',
    lateShort: 'Muộn {{minutes}}′',
    earlyShort: 'Sớm {{minutes}}′',
    punches: 'Lượt chấm',
    code: 'Mã chấm công: {{code}}',
  },
  board: {
    title: 'Bảng công',
    description: 'Công cả công ty theo tháng, tính từ máy chấm công.',
    person: 'Nhân viên',
    total: 'Công',
    late: 'Muộn',
    early: 'Sớm',
    missing: 'Thiếu',
    absent: 'Vắng',
    empty: 'Chưa ai được ghép mã chấm công.',
    unmatched_one: '{{count}} mã chấm công có lượt chấm nhưng chưa ghép với nhân viên.',
    unmatched_other: '{{count}} mã chấm công có lượt chấm nhưng chưa ghép với nhân viên.',
    match: 'Ghép mã',
    legend: '✓ đủ công · ½ nửa ngày · ! thiếu chấm công · ✕ vắng',
  },
  devices: {
    title: 'Máy chấm công',
    description: 'Trạm đọc máy chấm công, ghép mã chấm công với nhân viên và giờ làm.',
    clocks: 'Máy chấm công',
    noClock:
      'Chưa có máy nào gửi dữ liệu. Hãy tạo khoá trạm và chạy chương trình trạm trong văn phòng.',
    serial: 'Số seri {{serial}}',
    lastSeen: 'Liên lạc lần cuối',
    lastPunch: 'Lượt chấm mới nhất',
    never: 'Chưa có',
    stations: 'Trạm chấm công',
    stationsHint:
      'Chương trình chạy trên máy tính trong văn phòng, đọc máy chấm công qua mạng LAN và gửi lên Portal.',
    addStation: 'Tạo khoá trạm',
    stationName: 'Tên trạm',
    stationNameHint: 'Ví dụ: Máy tính lễ tân',
    keyTitle: 'Khoá trạm',
    keyHint:
      'Khoá chỉ hiện một lần. Ghi vào file .env của máy chạy trạm: ATTENDANCE_STATION_KEY=… rồi khởi động lại trạm.',
    revoke: 'Thu hồi',
    revokeConfirm: 'Thu hồi khoá của trạm "{{name}}"? Trạm sẽ không gửi được dữ liệu nữa.',
    revoked: 'Đã thu hồi',
    agentVersion: 'phiên bản {{version}}',
    hours: 'Giờ làm',
    hoursHint: 'Dùng để tính công, đi muộn, về sớm.',
    morning: 'Buổi sáng',
    afternoon: 'Buổi chiều',
    workdays: 'Ngày làm việc',
    codes: 'Mã chấm công',
    codesHint:
      'Ghép mỗi mã trên máy với một nhân viên (kể cả người chưa có tài khoản Portal). Lượt chấm cũ cũng được tính khi ghép. Chưa thấy người cần ghép: thêm hồ sơ ở Tổ chức → Nhân viên.',
    code: 'Mã',
    nameOnClock: 'Tên trên máy',
    employee: 'Nhân viên',
    pickEmployee: 'Chọn nhân viên…',
    noAccount: 'chưa có tài khoản',
    lastPunchShort: 'Chấm gần nhất',
  },
  errors: {
    attendance: {
      already_matched: 'Nhân viên này đã được ghép với một mã chấm công khác.',
    },
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    retry: 'Retry',
    saved: 'Saved',
    loadError: 'Could not load the data',
    month: '{{month}}',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    copy: 'Copy',
    copied: 'Copied',
  },
  status: {
    full: 'Full day',
    half: 'Half day',
    missing: 'Missing punch',
    absent: 'Absent',
    pending: 'In progress',
    off: 'Off',
  },
  weekday: { 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun' },
  mine: {
    title: 'My attendance',
    description: 'Arrival, departure and attendance per day from the time clock.',
    personTitle: 'Attendance of {{name}}',
    noCode:
      'You are not matched to a time clock code yet. Ask HR to match your code on the clock to your employee profile.',
    units: 'Days worked',
    unitsOf: '{{units}} / {{days}} days',
    late: 'Late',
    early: 'Left early',
    times: '{{count}} times · {{minutes}} min',
    missing: 'Missing punches',
    absent: 'Absent',
    lateShort: 'Late {{minutes}}′',
    earlyShort: 'Early {{minutes}}′',
    punches: 'Punches',
    code: 'Time clock code: {{code}}',
  },
  board: {
    title: 'Timesheet',
    description: 'Company attendance per month, from the time clock.',
    person: 'Employee',
    total: 'Days',
    late: 'Late',
    early: 'Early',
    missing: 'Missing',
    absent: 'Absent',
    empty: 'Nobody is matched to a time clock code yet.',
    unmatched_one: '{{count}} code punched but is not matched to an employee.',
    unmatched_other: '{{count}} codes punched but are not matched to an employee.',
    match: 'Match codes',
    legend: '✓ full day · ½ half day · ! missing punch · ✕ absent',
  },
  devices: {
    title: 'Time clocks',
    description: 'Stations reading the time clock, matching codes to employees, working hours.',
    clocks: 'Time clocks',
    noClock:
      'No time clock has sent data yet. Create a station key and run the station in the office.',
    serial: 'Serial {{serial}}',
    lastSeen: 'Last contact',
    lastPunch: 'Latest punch',
    never: 'Never',
    stations: 'Stations',
    stationsHint:
      'A program on an office computer that reads the time clock over the LAN and uploads to the Portal.',
    addStation: 'Create station key',
    stationName: 'Station name',
    stationNameHint: 'E.g. Reception PC',
    keyTitle: 'Station key',
    keyHint:
      'Shown once. Put it in the station computer’s .env file: ATTENDANCE_STATION_KEY=… and restart the station.',
    revoke: 'Revoke',
    revokeConfirm: 'Revoke the key of station "{{name}}"? It will no longer be able to upload.',
    revoked: 'Revoked',
    agentVersion: 'version {{version}}',
    hours: 'Working hours',
    hoursHint: 'Used for attendance, late arrivals and early departures.',
    morning: 'Morning',
    afternoon: 'Afternoon',
    workdays: 'Working days',
    codes: 'Time clock codes',
    codesHint:
      'Match each code on the clock to an employee (with or without a Portal account). Earlier punches count once matched. Someone missing: add their profile in Organisation → Employees.',
    code: 'Code',
    nameOnClock: 'Name on the clock',
    employee: 'Employee',
    pickEmployee: 'Pick an employee…',
    noAccount: 'no account yet',
    lastPunchShort: 'Latest punch',
  },
  errors: {
    attendance: {
      already_matched: 'This employee is already matched to another code.',
    },
    generic: 'The action failed. Please try again.',
  },
};
